module.exports = __webpack_public_path__ + "img/demo.6d8bfc6c.png";